import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInDays } from 'date-fns';
import addDays from 'date-fns/addDays';
import * as c3 from 'c3';

import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FilterDateDiff
    ,FilterDist
    ,FilterSecToTime
} from "src/app/shared/filter";
import {
    FvmsCommonService
    ,FvmsUtilService
    ,FvmsApiAuthService
    ,FvmsApiDtgDriveSafeEcoService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.analytics.drive.safe.summary.component.html'
    ,styleUrls: ["./dtg.analytics.drive.safe.summary.component.scss"]
    ,providers: [FilterDateDiff,FilterDist,FilterSecToTime,DecimalPipe]
})
export class DtgAnalyticsDriveSafeSummaryComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    dateInfo:any;
    companyInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number = 1;
    listItem:any[] = [];
    currentUserInfo:any;
    userGroupId:number;
    dtgTeamId:string = "";
    listYear:number[] = [];
    listMonth:number[] = [];
    dtgUnitId:string = "";
    selectedYear:number = 2020;
    selectedMonth:number = 0;
    selectedDate:any;
    searchValue:string = "";
    selectedRow:number = -1;
    sumData:any;
    pointSafeMin:any;
    pointSafeMax:any;

    chartColors:any[] = ['#4fc3f7', '#fb8c00', '#7460ee', '#f62d51', '#20c997', '#2962FF', '#40c4ff', '#2961ff', '#ff821c', '#7e74fb'];
    chart01:any;
    chart02:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsUtilService: FvmsUtilService
        ,private filterDateDiff:FilterDateDiff
        ,private filterSecToTime:FilterSecToTime
        ,private fvmsCommonService: FvmsCommonService
        ,private filterDist:FilterDist
        ,private decimalPipe:DecimalPipe
        ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        let dateTimeInfo = this.fvmsCommonService.getDateInfo();
        this.excelPagingInfo.pageSize = 60*60*24;

        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
        }

        let tmpDateInfo = this.fvmsCommonService.getDateInfo();
        if(tmpDateInfo && tmpDateInfo.fromDate){
            this.selectedYear = tmpDateInfo.fromDate.year;
            this.selectedMonth = tmpDateInfo.fromDate.month;
        }else{
            let today = new Date();
            this.selectedYear = today.getFullYear();
            this.selectedMonth = today.getMonth() + 1;
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.clickSearch();
            });
    }

    ngOnInit() {
        // this.changeDate();
        // this.initChart01();
        // this.reloadListSum();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,searchValue:this.searchValue
            ,dtgGroupByRegDtYy:"Y"
            ,dtgGroupByRegDtMm:"Y"
            // ,dtgGroupByRegDtDd:"Y"
            // ,dtgGroupByTripCnt:"Y"
            ,dtgGroupByUnitId:"Y"
        };
        return searchInfo;
    }

    reloadListSum(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,searchValue:this.searchValue
            ,dtgGroupByRegDtYy:"Y"
            ,dtgGroupByRegDtMm:"Y"
        };
        this.fvmsCommonService.setIsLoading(true);
        let pagingInfoSum = new PagingInfo();
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,pagingInfoSum)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        console.log("sum",apiResponse.resultValue);
                        this.sumData = apiResponse.resultValue[0];
                        let dtFrom = parse(this.sumData.dtgRegDtFrom,"yyyy-MM-dd HH:mm:ss",new Date());
                        let dtTo = parse(this.sumData.dtgRegDtTo,"yyyy-MM-dd HH:mm:ss",new Date());
                        let diffDay = differenceInDays(dtTo,dtFrom) + 1;
                        // console.log("diffday",diffDay);
                        this.sumData.diffDay = diffDay;
                        // this.sumData.avgRule1 = (this.sumData.cntRule1 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule2 = (this.sumData.cntRule2 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule3 = (this.sumData.cntRule3 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule4 = (this.sumData.cntRule4 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule5 = (this.sumData.cntRule5 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule6 = (this.sumData.cntRule6 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule7 = (this.sumData.cntRule7 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule8 = (this.sumData.cntRule8 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule9 = (this.sumData.cntRule9 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule10 = (this.sumData.cntRule10 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule101 = (this.sumData.cntRule101 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgRule102 = (this.sumData.cntRule102 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgDurRule1 = (this.sumData.durRule1 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgDurRule2 = (this.sumData.durRule2 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgDurRule101 = (this.sumData.durRule101 / this.sumData.dtgDriveCarCnt);
                        // this.sumData.avgDurRule102 = (this.sumData.durRule102 / this.sumData.dtgDriveCarCnt);
                        this.reloadListItem();
                    }
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        if(this.pagingInfo.startIndex < 0){
            this.pagingInfo.startIndex = 0;
        }
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listItem =[];
                this.selectedRow = -1;
                this.pointSafeMin = null;
                this.pointSafeMax = null;
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        this.pagingInfo = apiResponse.pagingInfo;
                        let sizeList = this.listItem.length;
                        for(let a=0;a<sizeList;a++){
                            let item = this.listItem[a];
                            this.calcDrivePoint(item);

                            if(!this.pointSafeMin){
                                this.pointSafeMin = JSON.parse(JSON.stringify(item));
                            }
                            if(!this.pointSafeMax){
                                this.pointSafeMax = JSON.parse(JSON.stringify(item));
                            }

                            if(this.pointSafeMin.pointSafe === 0 || this.pointSafeMin.pointSafe >= item.pointSafe){
                                this.pointSafeMin = JSON.parse(JSON.stringify(item));
                            }
                            if(this.pointSafeMax.pointSafe <= item.pointSafe){
                                this.pointSafeMax = JSON.parse(JSON.stringify(item));
                            }

                            //this.loadChart01Data(-1);

                        }
                        this.loadChart01Data(-1);
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    //https://patentimages.storage.googleapis.com/9f/53/ed/37541ca9d0c36d/KR101803662B1.pdf
    // 100-97 : 매우안전
    //  96-93 : 안전
    //  92-89 : 보통
    //  88-85 : 위험
    //  84-74 : 매우위험
    calcDrivePoint(item){
        if(item){
            if(item.dtgDistAccumul === 0){
                item.pointSafe = 0;
                item.cntRulePer100 = 0;
                return;
            }
            let dist = (item.dtgDistAccumul * 0.001 || 1);//운행거리 km 단위로 변경
            let cntRule1Per100  = ((item.cntRule1  * 100) / dist);//100km당 횟수
            let cntRule2Per100  = ((item.cntRule2  * 100) / dist);
            let cntRule3Per100  = ((item.cntRule3  * 100) / dist);
            let cntRule4Per100  = ((item.cntRule4  * 100) / dist);
            let cntRule5Per100  = ((item.cntRule5  * 100) / dist);
            let cntRule6Per100  = ((item.cntRule6  * 100) / dist);
            let cntRule7Per100  = ((item.cntRule7  * 100) / dist);
            let cntRule8Per100  = ((item.cntRule8  * 100) / dist);
            let cntRule9Per100  = ((item.cntRule9  * 100) / dist);
            let cntRule10Per100 = ((item.cntRule10 * 100) / dist);

            //안전운전지수 = 100키로당 횟수 * (기본 가중치 + 추가 가중치)
            let rule1DangerPt  = cntRule1Per100  * (0.083 + 0.083);//과속
            let rule2DangerPt  = cntRule2Per100  * (0.083 + 0.083);//장기과속
            let rule3DangerPt  = cntRule3Per100  * (0.180 + 0.180);//급가속
            let rule4DangerPt  = cntRule4Per100  * (0.180 + 0.180);//급출발
            let rule5DangerPt  = cntRule5Per100  * (0.264 + 0.264);//급감속
            let rule6DangerPt  = cntRule6Per100  * (0.264 + 0.264);//급정지
            let rule7DangerPt  = cntRule7Per100  * (0.245 + 0.245);//급진로변경
            let rule8DangerPt  = cntRule8Per100  * (0.245 + 0.245);//급앞지르기
            let rule9DangerPt  = cntRule9Per100  * (0.228 + 0.228);//급좌우회전
            let rule10DangerPt = cntRule10Per100 * (0.228 + 0.228);//급유턴

            //100키로당 횟수
            item.cntRule1Per100  = cntRule1Per100;
            item.cntRule2Per100  = cntRule2Per100;
            item.cntRule3Per100  = cntRule3Per100;
            item.cntRule4Per100  = cntRule4Per100;
            item.cntRule5Per100  = cntRule5Per100;
            item.cntRule6Per100  = cntRule6Per100;
            item.cntRule7Per100  = cntRule7Per100;
            item.cntRule8Per100  = cntRule8Per100;
            item.cntRule9Per100  = cntRule9Per100;
            item.cntRule10Per100 = cntRule10Per100;

            //안전운전지수
            item.rule1DangerPt  = rule1DangerPt;
            item.rule2DangerPt  = rule2DangerPt;
            item.rule3DangerPt  = rule3DangerPt;
            item.rule4DangerPt  = rule4DangerPt;
            item.rule5DangerPt  = rule5DangerPt;
            item.rule6DangerPt  = rule6DangerPt;
            item.rule7DangerPt  = rule7DangerPt;
            item.rule8DangerPt  = rule8DangerPt;
            item.rule9DangerPt  = rule9DangerPt;
            item.rule10DangerPt = rule10DangerPt;

            //100키로당 횟수 합산
            let sumCntPer100 = cntRule1Per100 + cntRule2Per100 + cntRule3Per100 + cntRule4Per100 + cntRule5Per100;
            sumCntPer100 += cntRule6Per100 + cntRule7Per100 + cntRule8Per100 + cntRule9Per100 + cntRule10Per100;

            //안전운전지수 합산
            let sumDangerPt = rule1DangerPt + rule2DangerPt + rule3DangerPt + rule4DangerPt + rule5DangerPt;
            sumDangerPt += rule6DangerPt + rule7DangerPt + rule8DangerPt + rule9DangerPt + rule10DangerPt;


            //100키로당 횟수 합산
            item.cntRulePer100 = sumCntPer100;

            //안전운전지수
            item.pointSafe = 100 - sumDangerPt;
        }
    }

    clickSearch(){
        // this.pagingInfo.curPage = 1;
        this.changeDate();
        this.initChart01();
        this.reloadListSum();
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    changeYear(e){
        this.changeDate();
        //this.clickSearch();
    }

    changeMonth(e){
        this.changeDate();
        //this.clickSearch();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.changeDate();
        this.clickSearch();
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.clickSearch();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.clickSearch();
    }

    initChart01(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart-01'
            ,data: {
                type:"donut"
                // ,json:[]
                ,columns:[
                    ["-",0]
                ]
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,tooltip:{
                format:{
                    value:function (value, ratio, id, index) {
                        return self.decimalPipe.transform(value,"0.0-1");
                    }
                }
            }
            ,legend: {
                hide: true
            }
        });
    }

    loadChart01Data(idx:number = -1){
        if(this.listItem){
            let listData = {};
            let listName = [];
            let listItems = [];

            if(this.pointSafeMin){
                listData[this.pointSafeMin.dtgCarNo] = this.pointSafeMin.pointSafe;
                listName.push(this.pointSafeMin.dtgCarNo);
                listItems.push([this.pointSafeMin.dtgCarNo,this.pointSafeMin.pointSafe]);
            }
            if(this.pointSafeMax){
                listData[this.pointSafeMax.dtgCarNo] = this.pointSafeMax.pointSafe;
                if(this.pointSafeMin.dtgCarNo !== this.pointSafeMax.dtgCarNo){
                    listName.push(this.pointSafeMax.dtgCarNo);
                    listItems.push([this.pointSafeMax.dtgCarNo,this.pointSafeMax.pointSafe]);
                }
            }

            if(listData){
                this.chart01.load({
                    // json:[listData]
                    columns:listItems
                    ,keys:{
                        value:listName
                    }
                    ,unload: true
                });
            }
        }
    }
}
